import { getStoreMarks } from '../../libs/prose-util';
import { DropCursorView } from './drop-cursor-view';
var shouldInsertParagraph = function (child) {
    // `notLastLine` is used to declare that the node shouldn't be the last line
    if (!child || child.type.spec.notLastLine)
        return true;
    var lastChild = child;
    while (lastChild) {
        if (!lastChild.lastChild)
            break;
        lastChild = lastChild.lastChild;
    }
    return !lastChild.isTextblock || Boolean(lastChild.content.size);
};
var BasicView = /** @class */ (function () {
    function BasicView(view, config) {
        this.config = config;
        if (config.dropCursor !== false) {
            this.dropCursor = new DropCursorView(view, typeof config.dropCursor !== 'object' ? undefined : config.dropCursor);
        }
    }
    BasicView.prototype.update = function (view, prevState) {
        this.dropCursor && this.dropCursor.update(view, prevState);
        var state = view.state, _a = view.state, doc = _a.doc, tr = _a.tr, dispatch = view.dispatch;
        var lastChild = doc.lastChild;
        // it would insert paragraph even if `keepLastLine` is `false`, when the lastChild is `atom`.
        if (this.config.keepLastLine === false && lastChild && !lastChild.type.isAtom)
            return;
        if (!shouldInsertParagraph(lastChild))
            return;
        var marks = getStoreMarks(state);
        dispatch(tr
            .insert(doc.nodeSize - 2, state.schema.topNodeType.contentMatch.defaultType.create())
            .ensureMarks(marks)
            .setMeta('addToHistory', false));
    };
    BasicView.prototype.destroy = function () {
        this.dropCursor && this.dropCursor.destroy();
    };
    return BasicView;
}());
export { BasicView };
//# sourceMappingURL=basic-view.js.map